export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_LIGHT = "/qairo-logo-light.png?v=3";
export const LOGO_DARK = "/qairo-logo-dark.png?v=3";
